import { createReducer } from '@reduxjs/toolkit';
import { LabelDto } from '../../api/ClientApi';
import {
    addMultipleArticleLabelToRedux,
    addNewArticleLabelToRedux,
    importArticleLabels,
} from '../actions/labelActions';

export interface LabelsState {
    articleLabels: LabelDto[] | null;
}

export const labelsReducer = createReducer<LabelsState>(
    {
        articleLabels: null,
    },
    (builder) => {
        builder
            .addCase(importArticleLabels.fulfilled, (state: LabelsState, action: any) => {
                const labels: LabelDto[] = action.payload;

                state.articleLabels = labels;
            })
            .addCase(addNewArticleLabelToRedux, (state: LabelsState, action: any) => {
                const label: LabelDto = action.payload;

                if (!state.articleLabels) {
                    state.articleLabels = [label];
                } else {
                    const existingLabelIndex = state.articleLabels?.findIndex(
                        (l) =>
                            l.id === label.id ||
                            (l.title?.toLowerCase().trim() === label.title?.toLowerCase().trim() &&
                                l.labelCategory === label.labelCategory),
                    );

                    if (!!existingLabelIndex && existingLabelIndex >= 0) {
                        state.articleLabels.splice(existingLabelIndex, 1, label);
                    } else {
                        state.articleLabels.push(label);
                    }
                }
            })
            .addCase(addMultipleArticleLabelToRedux, (state: LabelsState, action: any) => {
                const newLablesList = action.payload as LabelDto[];

                const oldLabelsList = state.articleLabels ? [...state.articleLabels] : [];

                newLablesList.map((newLabel) => {
                    if (!!newLabel) {
                        const oldLabel = oldLabelsList?.find((g) => g.id === newLabel.id);

                        if (!oldLabel) {
                            oldLabelsList.unshift(newLabel);
                        }
                    }
                });

                state.articleLabels = oldLabelsList;
            });
    },
);
